// extracted by mini-css-extract-plugin
export var wrapper = "Footer-module--wrapper--1Ah_D";
export var container = "Footer-module--container--1RDYA";
export var list = "Footer-module--list--1dXlD";